import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";

export interface WebPushSubscription {
  endpoint: string;
  tenant_id: string;
  user_id: string;
  user_name: string;
  device: Record<string, any>;
  last_accessed: number;
}

export interface WebPushNotification {
  tenant_id: string;
  user_id: string;
  endpoint: string;
  title: string;
  message: string;
  link: string;
}

@Injectable({
  providedIn: 'root'
})
export class PushNotificationsService {

  constructor(private http: HttpClient) { }

  getSubscriptions(): Observable<WebPushSubscription[]> {
    return this.http.get<WebPushSubscription[]>(`${environment.yomaApiURL}/web-push/subscriptions`);
  }

  sendNotification(notification: WebPushNotification): Observable<any> {
    return this.http.post(`${environment.yomaApiURL}/web-push/notifications`, notification);
  }

}
